import React from 'react';

export function ProgressBar({ value = 0, max = 100, className = '' }) {
  const pct = max > 0 ? Math.min(100, Math.max(0, (value / max) * 100)) : 0;
  return (
    <div className={`ds-progress ${className}`.trim()} role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
      <div className="ds-progress__fill" style={{ width: `${pct}%` }} />
    </div>
  );
}

export default ProgressBar;
